import * as React from 'react';

type DisplayBlockProps = {
    title: string;
    value: string | number;
};

export function formatPrice(value: number, currencyCode: string, locale?: string) {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        notation: 'standard',
    });
    return formatter.format(value);
}

export function formatNumber(value: number) {
    const formatter = new Intl.NumberFormat('en-IN', {
        maximumFractionDigits: 2,
    });
    return formatter.format(value);
}

export function calculateUnitsFromAmount(nav: number, amount: number | undefined): number {
    if (!amount) return 0;
    return amount / nav;
}

export function calculateAmountFromUnits(nav: number, amount: number | undefined): number {
    if (!amount) return 0;
    return amount * nav;
}

export const DisplayBlock = ({ title, value }: DisplayBlockProps) => {
    return (
        <div className="profile-details-info">
            <p>{title}</p>
            {typeof value == 'string' ? <h6>{value}</h6> : <h6>{formatPrice(value, 'INR')}</h6>}
        </div>
    );
};
